import { Transform, Type } from 'class-transformer';
import { dateJSONTransformer } from '../../../_constants/validation-format-constants';

export class AAPUserMetricsParameterDto {
    aapUserId: string;
    companyId: number;

    @Type(() => Date)
    @Transform(dateJSONTransformer, { toPlainOnly: true })
    fromDate: Date;

    @Type(() => Date)
    @Transform(dateJSONTransformer, { toPlainOnly: true })
    toDate: Date;

    getQueryString(): string {
        const tokens = [`toDate=${dateJSONTransformer(this.toDate)}`, `fromDate=${dateJSONTransformer(this.fromDate)}`];
        if (this.aapUserId) {
            tokens.push(`aapUserId=${this.aapUserId}`);
        }
        if (this.companyId) {
            tokens.push(`companyId=${this.companyId}`);
        }
        return `?${tokens.join('&')}`;
    }
}
